/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm', 'md' ] },
      tokens: {
        titleHeadingFontName: 'StagSans',
        titleHeadingFontSize: 32,
        titleHeadingFontWeight: '700',
        titleHeadingLineHeight: 1.25
      }
    }
  ],
  tokens: {
    backgroundGradient: {
      angle: 0,
      stops: [ { color: '#000000', stop: 0 }, { color: '#000000', stop: 1 } ],
      type: 'linear'
    },
    color: '#000000',
    linkFontName: 'StagSans',
    linkFontSize: 16,
    linkFontWeight: '600',
    linkLineHeight: 1.5,
    marginBottom: 16,
    paddingBottom: 16,
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 16,
    titleFontName: 'StagSans',
    titleFontSize: 20,
    titleFontWeight: '400',
    titleHeadingFontName: 'StagSans',
    titleHeadingFontSize: 32,
    titleHeadingFontWeight: '700',
    titleHeadingLineHeight: 1.25,
    titleLineHeight: 1.4,
    width: 4
  }
}
export default theme
